import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';
import Page from '../../components/Page';
import AvailabilityCalendar from './AvailabilityCalendar';

// ---------------------------------------------------------------------

export default function AvailabilityIndex() {
  const { t } = useTranslation();

  return (
    <Page title={t('calendar')}>
      <Container maxWidth="xl">
        <Typography variant="h4" fontWeight={800} gutterBottom mb={4}
          sx={{ color: '#032C65' }}
        >
          {t('calendar')}
        </Typography>
        <Box sx={{ background: '#fff', borderRadius: 3, p: { xs: 2, md: 4 }, boxShadow: '0 1px 8px 0 rgba(3,44,101,0.07)' }}>
          <AvailabilityCalendar />
        </Box>
      </Container>
    </Page>
  );
}